<eo-base-view [label]="label">
  <span [id]="id"> {{ getFormattedValue() }}</span>
</eo-base-view>
